import i18n from '@/settings/i18n';
import React from 'react';

import { Dropdown } from 'semantic-ui-react';

import './css/LanguageSwitcher.css';

const languageOptions = {
  ja: '日本語',
  en: 'English',
};

export const LanguageSwitcher: React.FC = () => (
  <Dropdown
    className="language-switcher"
    data-test="language-switcher"
    options={Object.keys(languageOptions).map((language, index) => ({
      'data-test': `language-switcher-${language}`,
      active: language === i18n.languages[0],
      key: index,
      value: language,
      text: languageOptions[language],
      onClick: () => {
        i18n.changeLanguage(language);
        window.location.reload();
      },
    }))}
    text={languageOptions[i18n.languages[0]]}
    upward={true}
    selection={true}
  />
);
